module.exports = __webpack_public_path__ + "img/product_shiseido_1.3adf2401.png";